<template lang="pug">
.wrapper
  aiq-tooltip(:disabled="inWebchat"
              :effect="'dark'",
              placement="bottom",
              :content="url",
              :open-delay="500"
              ref="tooltipRef")
    a(:href="url"
      class="document_wrapper"
      @click.prevent="click"
      target="_blank"
      rel="noopener") Open file in new tab
      aiq-document-icon(:theme="theme"
                      :mimeType="fileMimeType"
                      :documentExtension="fileExtension"
                      :fileId="fileId")
</template>

<script>

import get from 'lodash/get';
import has from 'lodash/has';

export default {
  inject: ['getSignedSource'],
  props: {
    senderType: { type: String, required: true },
    url: { type: String, required: true },
    inWebchat: { type: Boolean, required: true },
    attachment: Object,
  },
  emits: ['link'],
  data() {
    return {
      resolvedUrl: '',
    };
  },
  async mounted() {
    // Remove aria-describedby because description is already provided inline
    // and it's set by element-ui to an element we cannot control
    /* TODO: VUE3+ElementPlus
    const tooltipRef = this.$refs.tooltipRef.$el;
    tooltipRef.removeAttribute('aria-describedby');
    */

    this.resolvedUrl = this.url;
    if (this.containFileMeta) {
      this.resolvedUrl = get(this.attachment, 'url', this.resolvedUrl);

      // if attachment exists, it has all file structures that
      // it needs to presign url
      if (this.isFilePrivate) {
        this.resolvedUrl = await this.getSignedSource(this.bucket, this.key);
      }
    }
  },
  computed: {
    theme() {
      if (this.inWebchat) {
        return this.senderType === 'customers' ? 'white' : 'blue';
      }
      return this.senderType === 'customers' ? 'blue' : 'white';
    },

    iconClass() {
      let darkOrLight = this.senderType !== 'customers';
      if (this.inWebchat) {
        darkOrLight = !darkOrLight;
      }
      // TODO: Define the icons to show for other types
      const type = get(this.attachment, 'url.type', '');
      switch (type) {
        case 'html':
        case 'txt':
        case 'csv':
        case 'pdf':
        case 'doc':
        case 'docx':
        case 'odp':
        case 'ods':
        case 'odt':
        case 'ppt':
        case 'pptx':
        case 'rtf':
        case 'xls':
        case 'xlsx':
        default:
          return {
            'aiq-ico-doc-light': !darkOrLight,
            'aiq-ico-doc-dark': darkOrLight,
          };
      }
    },
    containFileMeta() {
      return this.attachment && has(this.attachment, 'acl')
        && has(this.attachment, 'bucket') && has(this.attachment, 'bucket');
    },
    isFilePrivate() {
      return get(this.attachment, 'acl', 'public') === 'private';
    },
    bucket() {
      return get(this.attachment, 'bucket', '');
    },
    key() {
      return get(this.attachment, 'key', '');
    },
    fileMimeType() {
      return get(this.attachment, 'mime', '');
    },
    fileExtension() {
      return get(this.attachment, 'filename', '').split('.').pop();
    },
    fileId() {
      return get(this.attachment, 'file_id', '').toString();
    },
  },
  methods: {
    async click(e) {
      if (this.resolvedUrl) {
        this.$emit('link', {
          type: 'document',
          url: this.resolvedUrl
        });
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.document_wrapper {
  width: 100%;
  cursor: pointer;
  font-size: 0px;
}
.wrapper {
  line-height: 0;
}
</style>
